import {Button, Col, Form, Row, Space, Spin, Table, Typography} from "antd";
import {InputFields, ListActionButton, Notification} from "components/common";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {
  detailPackageColums,
  detailServiceFields,
  packageColums,
  searchFields,
} from "./config";
import Icons from "assets/icons";
import "./ServicePackage.scss";
import TechnicalServiceModal from "./components/TechnicalServiceModal/TechnicalServiceModal";
import MedicalModal from "./components/MedicalModal/MedicalModal";
import OtherModal from "./components/OtherModal/OtherModal";
import VTYTModal from "./components/VTYTModal/VTYTModal";
import {servicePackage, technicalService} from "api";
import {setSiderKey} from "redux/reducer/common";
import {useAppDispatch} from "redux/hooks";

const ServicePackage = () => {
  const dispatch = useAppDispatch();
  document.title = "Gói dịch vụ";
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchForm] = Form.useForm();
  const [servicePackageInfoForm] = Form.useForm();
  const [payForm] = Form.useForm();
  const [sPackage, setSPackage] = useState<any>(null);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [selectedKeys, setSelectedKeys] = useState<any>([]);
  const [elementInPackage, setElementInPackage] = useState<any>(null);
  const [params, setParams] = useState<any>({});

  // ref
  const tSRef = useRef<any>();
  const mMRef = useRef<any>();
  const vtytRef = useRef<any>();
  const oMRef = useRef<any>();
  //
  const onTechnicalServiceModal = async () => {
    if (!selectedRecord) {
      Notification("info", "Hãy chọn gói dịch vụ trước!");
      return;
    }
    tSRef.current?.setData(null);
    tSRef.current?.openModal();
  };
  const onMedicalModal = async () => {
    if (!selectedRecord) {
      Notification("info", "Hãy chọn gói dịch vụ trước!");
      return;
    }
    mMRef.current?.setData(null);
    mMRef.current?.openModal();
  };
  const onVTYTModal = async () => {
    if (!selectedRecord) {
      Notification("info", "Hãy chọn gói dịch vụ trước!");
      return;
    }
    vtytRef.current?.setData(null);
    vtytRef.current?.openModal();
  };
  const onOtherModal = async () => {
    if (!selectedRecord) {
      Notification("info", "Hãy chọn gói dịch vụ trước!");
      return;
    }
    oMRef.current?.setData(null);
    oMRef.current?.openModal();
  };

  //
  const onSaveTS = async values => {
    try {
      let response = await servicePackage.postAddService2Package({
        ...values,
        idGoiDichVu: selectedRecord.id,
      });
      Notification("success", "Thêm thành công!");
      fetchServicePackage({
        id: selectedRecord.id,
      });
    } catch (err) {}
  };
  const onSaveMedical = async values => {
    try {
      let response = await servicePackage.postMedical2Package({
        ...values,
        idGoiDichVu: selectedRecord.id,
      });
      Notification("success", "Thêm thành công!");
      fetchServicePackage({
        id: selectedRecord.id,
      });
    } catch (err) {}
  };
  const onSaveOther = async values => {
    let response = await servicePackage.postOther2Package({
      ...values,
      idGoiDichVu: selectedRecord.id,
    });
    Notification("success", "Thêm thành công!");
    fetchServicePackage({
      id: selectedRecord.id,
    });
  };
  const onSaveVTYT = async values => {
    try {
      let response = await servicePackage.postVTYT2Package({
        ...values,
        idGoiDichVu: selectedRecord.id,
      });
      Notification("success", "Thêm thành công!");
      fetchServicePackage({
        id: selectedRecord.id,
      });
    } catch (err) {}
  };
  const onSaveAll = async () => {
    if (selectedRecord) {
      servicePackageInfoForm.validateFields().then(async values => {
        try {
          let response = await servicePackage.putServicePackage({
            ...selectedRecord,
            ...values,
            id: selectedRecord.id,
          });
          Notification("success", "Lưu thành công");
          fetchListServicePackage({
            ...params,
            page: page,
            limit: limit,
          });
        } catch (err) {}
      });
    } else {
      servicePackageInfoForm.validateFields().then(async values => {
        try {
          let response = await servicePackage.postServicePackage({
            ...values,
            trangThai: 0,
            chiTietGoiDichVuDtos: [],
          });
          setSelectedRecord({...response});
          setSelectedKeys([response.id]);
          Notification("success", "Lưu thành công");
          fetchListServicePackage({
            ...params,
            page: page,
            limit: limit,
          });
        } catch (err) {}
      });
    }
  };
  //
  const fetchListServicePackage = async params => {
    try {
      setLoading(true);
      let response = await servicePackage.getListServicePackage(params);
      setSPackage(response);
      setLoading(false);
    } catch (err) {}
  };
  const fetchServicePackage = async params => {
    try {
      let response = await servicePackage.getServicePackage(params);
      setSelectedRecord(response);
    } catch (err) {}
  };
  const [dmTrangThai, setDmTrangThai] = useState<any>([]);
  const fetchDanhMucTrangThai = async () => {
    try {
      setLoading(true);
      let response = await technicalService.getDanhMucTrangThai();
      setDmTrangThai(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const onSearchFinish = async values => {
    setParams({
      ...values,
    });
    fetchListServicePackage({
      ...values,
      page: page,
      limit: limit,
    });
  };
  const onSelectRow = async (selectedRowKeys, selectedRows, info) => {
    setSelectedRecord({
      ...selectedRows[0],
    });
    setSelectedKeys(selectedRowKeys);
  };
  const onAdd = async () => {
    setSelectedRecord(null);
    setSelectedKeys([]);
    servicePackageInfoForm.setFieldsValue({
      giaBv: 0,
    });
  };
  const delPackageFunc = async record => {
    try {
      let response = await servicePackage.deleteElement({
        id: record.id,
      });
      fetchServicePackage({
        id: selectedRecord.id,
      });
    } catch (err) {}
  };
  const onPaginationChange = async (pg, pgSize) => {
    setPage(pg);
    setLimit(pgSize);
    fetchListServicePackage({
      ...params,
      page: pg,
      limit: pgSize,
    });
  };
  detailPackageColums.map(it => {
    if (it.dataIndex === "action") {
      it.render = (v, r, i) => {
        return <ListActionButton deleteFunction={() => delPackageFunc(r)} />;
      };
    }
  });
  packageColums.map(it => {
    if (it.dataIndex === "trangThai") {
      it.render = (v, r, i) =>
        dmTrangThai.find(it => it.id === v)?.tenTTDichVuKyThuat || "";
    }
  });
  const handleDeletePageket = async id => {
    try {
      const res = await servicePackage.deletePageket(id);
      fetchListServicePackage({
        ...params,
        page: page,
        limit: limit,
      });
      Notification("error", "Xoá gói thành công");
    } catch (error) {
      Notification("error", "Xoá gói không thành công");
    }
  };

  packageColums.find(e => e.dataIndex === "actions").render = (
    v,
    r: {id: number},
    i
  ) => {
    return (
      <ListActionButton deleteFunction={() => handleDeletePageket(r.id)} />
    );
  };

  const mucBH = Form.useWatch("mucBH", servicePackageInfoForm);
  const giaBV = Form.useWatch("giaBV", servicePackageInfoForm);
  const mucBVGiam = Form.useWatch("mucBvGiam", servicePackageInfoForm);

  useMemo(() => {
    if (elementInPackage) {
      let giaBv = 0;
      let giaBh = 0;
      elementInPackage?.map(it => {
        giaBv += it.giaBv;
        giaBh += it.giaBHYT;
      });
      servicePackageInfoForm.setFieldsValue({
        giaBv: giaBv,
        giaBH: giaBh * (mucBH / 100),
        nbChiTra: giaBh * ((100 - mucBH) / 100),
        nbTuTra: giaBv - giaBh,
        tongNbTra: giaBv - giaBh + giaBh * ((100 - mucBH) / 100) - mucBVGiam,
      });
    }
  }, [elementInPackage, mucBH]);

  useEffect(() => {
    fetchListServicePackage({
      page: page,
      limit: limit,
    });
    fetchDanhMucTrangThai();
    dispatch(setSiderKey("goiDichVu"));
  }, []);
  useEffect(() => {}, [sPackage, dmTrangThai]);
  useEffect(() => {
    if (selectedRecord) {
      servicePackageInfoForm.setFieldsValue({
        tenGoiDichVu: selectedRecord.tenGoiDichVu,
        giaBv: selectedRecord.giaBv,
        mucBvGiam: selectedRecord.mucBVGiam,
        mucBH: selectedRecord.mucBH,
        giaBH: selectedRecord.giaBH,
        nbChiTra: selectedRecord.nbChiTra,
        nbTuTra: selectedRecord.nbTuTra,
        tongNbTra: selectedRecord.tongNbTra,
        trangThai: selectedRecord.trangThai,
      });
      setElementInPackage([...(selectedRecord?.chiTietGoiDichVuDtos ?? [])]);
    } else {
      servicePackageInfoForm.resetFields();
      setElementInPackage(null);
    }
  }, [selectedRecord]);
  return (
    <Spin spinning={loading}>
      <div className="service-package page">
        <div className="main">
          <div className="container">
            <Row>
              <Form form={searchForm} onFinish={onSearchFinish}>
                <Space direction="vertical">
                  <Row gutter={[8, 8]}>
                    <InputFields data={searchFields} />
                  </Row>
                  <Row justify="end">
                    <Button
                      type="primary"
                      icon={<Icons.search rev={0} />}
                      htmlType="submit"
                    >
                      Tìm kiếm
                    </Button>
                  </Row>
                </Space>
              </Form>
            </Row>
          </div>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={24} md={24} lg={10} xl={10}>
              <div className="container">
                <Row justify={"end"} style={{marginBottom: "4px"}}>
                  <Button
                    type="primary"
                    icon={<Icons.add rev={0} />}
                    onClick={onAdd}
                  >
                    Thêm
                  </Button>
                </Row>
                <Row>
                  <Table
                    rowKey={record => record.id}
                    columns={packageColums}
                    dataSource={sPackage ? sPackage.data : []}
                    loading={loading}
                    pagination={{
                      total: sPackage?.total,
                      pageSize: sPackage?.limit,
                      current: sPackage?.page,
                      onChange: onPaginationChange,
                      showSizeChanger: true,
                    }}
                    rowSelection={{
                      type: "radio",
                      onChange: onSelectRow,
                      selectedRowKeys: selectedKeys,
                    }}
                    bordered
                  />
                </Row>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={14} xl={14}>
              <div className="container">
                <Space direction="vertical">
                  <Row>
                    <Typography.Text strong>Chi tiết gói DV</Typography.Text>
                  </Row>
                  <Row>
                    <Row justify={"space-between"}>
                      <Col>
                        <Button
                          type="primary"
                          onClick={onTechnicalServiceModal}
                        >
                          Thêm DVKT
                        </Button>
                      </Col>
                      <Col>
                        <Space size={"small"}>
                          <Button type="primary" onClick={onMedicalModal}>
                            Thêm thuốc
                          </Button>
                          <Button type="primary" onClick={onVTYTModal}>
                            Thêm VTYT
                          </Button>
                          <Button type="primary" onClick={onOtherModal}>
                            Thêm Khác
                          </Button>
                          <Button type="primary" onClick={onSaveAll}>
                            Lưu
                          </Button>
                        </Space>
                      </Col>
                    </Row>
                    <Row>
                      <TechnicalServiceModal ref={tSRef} onSave={onSaveTS} />
                      <MedicalModal ref={mMRef} onSave={onSaveMedical} />
                      <OtherModal ref={oMRef} onSave={onSaveOther} />
                      <VTYTModal ref={vtytRef} onSave={onSaveVTYT} />
                    </Row>
                  </Row>
                  <Row>
                    <Form form={servicePackageInfoForm}>
                      <Space direction="vertical">
                        <Row gutter={[8, 8]}>
                          <InputFields data={detailServiceFields} />
                        </Row>
                      </Space>
                    </Form>
                  </Row>
                  <Row>
                    <Row>
                      <Table
                        columns={detailPackageColums}
                        dataSource={elementInPackage ? elementInPackage : []}
                        bordered
                      />
                    </Row>
                  </Row>
                </Space>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Spin>
  );
};

export default ServicePackage;
